var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActivityActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#52C9F4;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m21 6.3v13.3m4-9.2l-4-4.4m-4 4.4l4-4.4-4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m11 25.7v-13.3m4 9.2l-4 4.4m-4-4.4l4 4.4-4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0h32v32H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivityActive);
export default __webpack_public_path__ + "static/media/ic_activity_active.603e062020cac1c7ac152ecdef310225.svg";
export { ForwardRef as ReactComponent };